import axios from "axios";
import API_BASE_URL from "../config/apiConfig";
import { getAccessToken } from "../util/auth";

const getAuthConfig = () => {
  const token = getAccessToken();

  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
};

export const login = async ({ email, password }) => {
  const response = await axios.post(`${API_BASE_URL}/auth/login`, {
    email,
    password,
  });

  return response.data;
};

export const googleLogin = async ({ credential }) => {
  const response = await axios.post(`${API_BASE_URL}/auth/google`, {
    credential,
  });

  return response.data;
};

export const recordGoogleLoginEvent = async (event) => {
  const response = await axios.post(
    `${API_BASE_URL}/auth/google/login-events`,
    event,
    getAuthConfig(),
  );

  return response.data;
};

export const fetchMyGoogleLoginEvents = async () => {
  const response = await axios.get(`${API_BASE_URL}/auth/google/login-events/mine`, getAuthConfig());
  return response.data?.items || response.data || [];
};

export const fetchAllGoogleLoginEvents = async () => {
  const response = await axios.get(`${API_BASE_URL}/auth/google/login-events`, getAuthConfig());
  return response.data?.items || response.data || [];
};
